import React from "react";
import { withNavBars } from "../../HOCs";
import ProxyInvoice from "./proxyInvoice";
class ProxyInvoiceParent extends React.Component {
  render() {
    return <ProxyInvoice />;
  }
}
const props = {
  boxShadow: false,
};
export default withNavBars(ProxyInvoiceParent, props);
